export default "__VITE_ASSET__S3ECu43F__"